// src/theme/appTheme.js
import { createTheme } from "@mui/material/styles";

const headerBg = (theme) => theme.palette.grey[100];

export const appTheme = createTheme({
  components: {
    MuiTable: {
      defaultProps: { size: "small", stickyHeader: true },
      styleOverrides: {
        root: {
          "& th, & td": { paddingTop: 3, paddingBottom: 3, paddingLeft: 8, paddingRight: 8 },
        },
      },
    },
    

// Make ALL header cells grey + bold
    MuiTableCell: {
      styleOverrides: {
        head: ({ theme }) => ({
      backgroundColor: theme.palette.grey[100],
      fontWeight: 700,
      paddingTop: 6,   // ↓ tighter header height
      paddingBottom: 6,
    }),
    root: {
      verticalAlign: "middle",
      paddingTop: 6,   // ↓ tighter body row height
      paddingBottom: 6,
    },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: { borderRadius: 12 },
      },
    },
    MuiButton: {
      styleOverrides: { root: { borderRadius: 12 } },
    },
    MuiChip: {
      styleOverrides: { root: { borderRadius: 10 } },
    },
  },
  typography: {
    tableHeader: { fontWeight: 700 },
  },
});
